<template>
  <v-container class="py-1 px-0 px-md-3" fluid>
    <v-row>
      <v-col md="9" cols="12">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <v-select
              v-model="sortBy"
              :items="sortOptions"
              label="Ordenar por"
              v-on:change="onSortChange"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="2"
            offset-md="4"
            class="d-flex justify-end align-center mb-2"
            v-if="dataset.allowDownload"
          >
            <v-menu close-on-click offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  style="color: rgba(0, 0, 0, 0.7)"
                  v-bind="attrs"
                  v-on="on"
                  small
                  block
                >
                  <v-icon size="18" class="mr-2">cloud_download</v-icon>
                  Exportar
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in exportFormats"
                  :key="index"
                  @click.stop="exportMetadata(item)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <div
          v-if="results.length > 0"
          style="max-height: 80vh; overflow-y: scroll"
        >
          <v-row v-for="r in results" :key="r._id" no-gutters>
            <v-col cols="12" class="py-0">
              <result :id="r._id" :source="r._source" :hits="r.inner_hits" />
            </v-col>
          </v-row>
        </div>
        <v-card class="mt-2 mb-3" v-else>
          <v-card-text>No hay resultados!</v-card-text>
        </v-card>
      </v-col>
      <v-col md="3" cols="12">
        <right-filters @filter="filter" :filterOptions="filterOptions" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Result from "@/components/dashboard/data/Result.vue";
import RightFilters from "@/components/dashboard/filters/RightFilters.vue";
export default {
  data() {
    return {
      sortBy: "_score",
      sortOptions: [
        {
          value: "_score",
          text: "Relevancia",
        },
        {
          value: "popularity_count",
          text: "Popularidad",
        },
        {
          value: "creation_time_desc",
          text: "Fecha más reciente",
        },
        {
          value: "creation_time_asc",
          text: "Fecha más antiguo",
        },
      ],
    };
  },
  components: {
    Result,
    RightFilters,
  },
  props: {
    dataset: {
      type: Object,
      required: true,
    },
    results: {
      type: Array,
      default: () => [],
    },
    filterOptions: {
      type: Object,
      default: () => {},
    },
    exportFormats: {
      type: Array,
      default: () => ["CSV", "EXCEL"],
    },
  },
  methods: {
    onSortChange() {
      console.log(this.sortBy);
      this.$emit("sort", this.sortBy);
    },
    filter(filters) {
      this.$emit("filter", filters);
    },
    exportMetadata(format) {
      this.$eventBus.$emit("newTask", {
        taskType: "exportData",
        taskData: {
          datasetUid: this.dataset.uid,
          format,
        },
      });
    },
  },
};
</script>

<style>
</style>